import cn from 'classnames';
import { getTranslation } from '../../helpers';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';

const CartRemove = ({ item, className }) => {
  const { removeLineItem } = useCartContext();

  return (
    <button
      class={cn(className, 'flex text-black/50')}
      aria-label={getTranslation('cart.remove_item')}
      type="button"
      onClick={() => removeLineItem(item.key)}
    >
      <svg
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="size-4"
      >
        <path
          d="M3.28125 3.28125L3.86719 12.6562C3.89502 13.1979 4.28906 13.5938 4.80469 13.5938H10.1953C10.713 13.5938 11.0997 13.1979 11.1328 12.6562L11.7188 3.28125"
          stroke="currentColor"
          strokeWidth="0.9375"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path d="M2.34375 3.28125H12.6562H2.34375Z" fill="currentColor"></path>
        <path
          d="M2.34375 3.28125H12.6562"
          stroke="currentColor"
          strokeWidth="0.9375"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M9.60938 5.15625L9.375 11.7188M5.625 3.28125V2.10938C5.62473 2.01697 5.64273 1.92541 5.67797 1.83998C5.71321 1.75455 5.76499 1.67693 5.83034 1.61159C5.89568 1.54624 5.9733 1.49446 6.05873 1.45922C6.14416 1.42398 6.23571 1.40598 6.32812 1.40625H8.67188C8.76429 1.40598 8.85584 1.42398 8.94127 1.45922C9.0267 1.49446 9.10432 1.54624 9.16966 1.61159C9.23501 1.67693 9.28679 1.75455 9.32203 1.83998C9.35727 1.92541 9.37527 2.01697 9.375 2.10938V3.28125H5.625ZM7.5 5.15625V11.7188V5.15625ZM5.39062 5.15625L5.625 11.7188L5.39062 5.15625Z"
          stroke="currentColor"
          strokeWidth="0.9375"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    </button>
  );
};

export default CartRemove;
